import { createSelector } from 'reselect';
import { TimeUnit } from '@mews/enums';
import { getTimeUnitByServiceId } from '@mews-commander/legacy-entities/src/ducks';
import {
    getIsOverlappingNextTimeUnit,
    isArrivalTimeAfterDepartureTime,
} from '@mews-commander/legacy-entities/src/ducks/services';
import { getEndTime, getStartTime, sameDayOrder } from './order';
import { getHasMultipleServices } from './services';
import { getHasOnlyNightlyServices } from './entities';
import { getSelectedAvailabilityBlockId } from './screens';

export const getMinDayDifference = createSelector(
    (state, { serviceId }) => getIsOverlappingNextTimeUnit(state, { id: serviceId }),
    getHasMultipleServices,
    getHasOnlyNightlyServices,
    getSelectedAvailabilityBlockId,
    (isOverlappingNextTimeUnit, isMultiServiceProperty, hasCategoryOnlyNightlyServices, availabilityBlockId) =>
        (availabilityBlockId && isOverlappingNextTimeUnit) ||
        hasCategoryOnlyNightlyServices ||
        (!isMultiServiceProperty && isOverlappingNextTimeUnit)
            ? 1
            : 0
);

export const getShowDateServiceDiscrepancyBanner = createSelector(
    (state, { serviceId }) => getIsOverlappingNextTimeUnit(state, { id: serviceId }),
    sameDayOrder,
    getTimeUnitByServiceId,
    (state, { serviceId }) => isArrivalTimeAfterDepartureTime(state, { id: serviceId }),
    (isOverlappingNextTimeUnit, isSingleDay, timeUnit, arrivalTimeAfterDepartureTime) =>
        !!(
            isSingleDay &&
            ((timeUnit === TimeUnit.Day && isOverlappingNextTimeUnit) ||
                (timeUnit === TimeUnit.Month && arrivalTimeAfterDepartureTime))
        )
);

export const getShowTimeServiceDiscrepancyBanner = createSelector(
    getStartTime,
    getEndTime,
    getTimeUnitByServiceId,
    (startTime, endTime, timeUnit) => !startTime && !endTime && timeUnit === TimeUnit.Hour
);
